import { gsap } from "../gsap/all.js";
import { ScrollTrigger } from "../gsap/ScrollTrigger.js";
import A11yDialog from "a11y-dialog";
gsap.registerPlugin(ScrollTrigger);
gsap.config({nullTargetWarn:false});
export default {

  init() {

    // INIT ACQ POPUP

    if (!sessionStorage.getItem('acqModalDismissed')) {
      const modal = new Foundation.Reveal($('#acq'));
      setTimeout(() => {
        modal.open();
      }, 1000);
    }

    /* Assessment Tool Code - Start */
    function scrollToTop() {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
    }

    $(document).ready(function() {
    // Capture the initial value of MM_1_Description_of_Organization__c once on document ready
    let organizationValue = $('form.mktoForm input[name="MM_1_Description_of_Organization__c"]').val();

    // Retry logic if organizationValue is not immediately available
    if (!organizationValue) {
      setTimeout(() => {
        organizationValue = $('form.mktoForm input[name="MM_1_Description_of_Organization__c"]').val();
      }, 1000);
    }

    if ($('.assessment_tool').length >= 1) {

      var answerArray = {};

      const max = parseInt($('.assessment_tool').attr('data-max'), 10),
      prog = Math.ceil(100 / max);

      $(document).on('click', '.ass-next:not(.disabled)', function(e) {
        e.preventDefault();
        var next = parseInt($(this).attr('data-next'), 10),
        section = parseInt($('.ass-panel[data-panel="'+next+'"]').attr('data-section'), 10);

        if (next <= max) {
          if (parseInt($('.ass-time-section.active').attr('data-section'), 10) != section) {
            $('.ass-time-section.active').removeClass('active');
            $('.ass-time-section[data-section="'+section+'"]').addClass('active');
          }

          $('.ass-panel.active').removeClass('active');
          $('.ass-panel[data-panel="'+next+'"]').addClass('active');
          if (
            ($('.ass-panel[data-panel="'+next+'"]').attr('data-type') != 'section') &&
            ($('.ass-panel[data-panel="'+next+'"]').attr('data-answered') == 'no')
            ) {
            $(this).addClass('disabled');
        }

        var progress = next * prog;
        $('.ass-progress .progress-blur').css('width', progress+'vw');
        $('.ass-progress .progress-line').css('width', progress+'vw');

        if (next == max) {
          $(this).addClass('hidden');
          $('.ass-finish').removeClass('hidden');
        } else {
          next++;
          $(this).attr('data-next', next);

          $('.ass-prev').attr('data-prev', (next - 2));
          if ((next - 1) > 0) {
            $('.ass-prev').removeClass('disabled');
          } else {
            $('.ass-prev').addClass('disabled');
          }
        }
      }

      scrollToTop();
    });

      $(document).on('click', '.ass-prev:not(.disabled)', function(e) {
        e.preventDefault();
        var prev = parseInt($(this).attr('data-prev'), 10),
        section = parseInt($('.ass-panel[data-panel="'+prev+'"]').attr('data-section'), 10);

        if (prev >= 1) {
          if (parseInt($('.ass-time-section.active').attr('data-section'), 10) != section) {
            $('.ass-time-section.active').removeClass('active');
            $('.ass-time-section[data-section="'+section+'"]').addClass('active');
          }

          $('.ass-panel.active').removeClass('active');
          $('.ass-panel[data-panel="'+prev+'"]').addClass('active');

          prev--;
          $(this).attr('data-prev', prev);

          var progress = prev * prog;
          $('.ass-progress .progress-blur').css('width', progress+'vw');
          $('.ass-progress .progress-line').css('width', progress+'vw');

          if ((prev - 1) <= 0) {
            $('.ass-prev').addClass('disabled');
          }
          $('.ass-next').attr('data-next', (prev + 2));
          $('.ass-next.disabled').removeClass('disabled');
          $('.ass-finish:not(.hidden)').addClass('hidden');
          $('.ass-next.hidden').removeClass('hidden');
        }

        scrollToTop();
      });

      $(document).on('click', '.ass-answer', function(e) {
        e.preventDefault();
        var type = $(this).attr('data-type'),
        score = parseInt($(this).attr('data-score'), 10),
        question = $(this).attr('data-question'),
        qGroup = $(this).attr('data-group'),
        count = $(this).attr('data-group-count'),
        answer = $(this).text(),
        weight = $(this).attr('data-qtype');

        if (count > 1) {
          var acount = 0;
          $('.ass-panel[data-question="'+question+'"] .ass-answer-group[data-group="'+qGroup+'"]').attr('data-answered', 'yes');

          $('.ass-panel[data-question="'+question+'"] .ass-answer-group').each(function() {
            if ($(this).attr('data-answered') == 'yes') {
              acount++;
            }
          }).promise().done(function() {
            if (acount == count) {
              $('.ass-panel[data-question="'+question+'"]').attr('data-answered', 'yes');
              $('.ass-next.disabled').removeClass('disabled');
            }
          });
        } else {
          $('.ass-panel[data-question="'+question+'"]').attr('data-answered', 'yes');
          $('.ass-next.disabled').removeClass('disabled');
        }

        if (type != 'checkbox') {
          if (!$(this).hasClass('selected')) {
            $('.ass-answer-group[data-question="'+question+'"][data-group="'+qGroup+'"] > .ass-answer.selected').removeClass('selected');
          }
        }

        $(this).toggleClass('selected');
      });

      var formIDs = [
      'MM_1_Description_of_Organization__c',
      'MM_2A_Member_Population_Type__c',
      'MM_2_B_Member_Population_Size__c',
      'MM_3_Type_of_Members_in_Population__c',
      'MM_4_Member_Population_Makeup__c',
      'MM_5_Primary_Growth_Strategy__c',
      'MM_6_Segment_of_Population_Growth__c',
      'MM_7_Current_Number_of_HMPs__c',
      'MM_8_Current_Implementation_Time__c',
      'MM_9_Data_Send_Types__c',
      'MM_10_Price_Transparency_Awareness__c',
      'MM_11_Data_Analyzation_Tools__c',
      'MM_12_Using_Analytic_Platforms__c',
      'MM_13_Benchmarking_Data_Usage__c',
      'MM_14_Transparency_Confidence__c',
      'MM_15_Confidence_Member_Info_Access__c',
      'MM_Result__c',
      ];

      $(document).on('click', '.ass-finish', function(e) {
        e.preventDefault();
        $(this).addClass('disabled');

        var con = 0,
        opt = 0,
        url = $(this).attr('data-result-page'),
        conV = '',
        optV = '';

        $('.ass-answer.selected').each(function(index) {
          let input, answer = $(this).text().trim();

          if (index > 0 && formIDs[index - 1] === formIDs[index]) {
            let currentVal = $('form.mktoForm input[name="' + formIDs[index] + '"]').val();
            answer = currentVal ? currentVal + ', ' + answer : answer;
          }

          if (index < formIDs.length) {
            input = formIDs[index];
            $('form.mktoForm input[name="' + input + '"]').val(answer);
          }
        }).promise().done(function() {
          optV = (opt > 10) ? 'optimized' : 'unoptimized';
          conV = (con > 3) ? 'connected' : 'disconnected';
          $('form.mktoForm input[name="MM_Result__c"]').val(optV + '-' + conV);

            // Explicitly set the organization value
            if (organizationValue) {
              $('form.mktoForm input[name="MM_1_Description_of_Organization__c"]').val(organizationValue);

              MktoForms2.whenReady(function(form) {
                form.setValues({
                  MM_1_Description_of_Organization__c: organizationValue,
                });
              });
            }

            $('#ass-thankyou').attr('data-url', url + '?ao=' + optV + '&ac=' + conV);
            $('form.mktoForm button.mktoButton').click();
          });
      });
    }
  });

MktoForms2.whenReady(function(form) {
  form.onSuccess(function(vals, tyURL) {
    document.location.href = $('#ass-thankyou').attr('data-url');
    return false;
  });
});

/* Assessment Tool Code - End */



$(document).on('click', '.load-more', function(e) {
  e.preventDefault();

  var id = $(this).attr('data-section'),
  postType = $(this).attr('data-post-type'),
  contains = $(this).attr('data-contains'),
  tag = $(this).attr('data-tag'),
  current = parseInt($(this).attr('data-current'), 10),
  max = $(this).attr('data-max');

  console.log(id);

  $('.load-more').attr('data-contains', contains);
  $('.load-more').attr('data-tag', tag);
  $('#' + id + ' .load-more').hide();
  $('#' + id + ' .pagination-count svg').show();
  $('#' + id + ' .pagination-count .no-posts').hide();

  $.ajax({
    url: ajaxurl + '?action=loadMorePosts',
    type: 'post',
    data: {
      section: id,
      postType: postType,
      contains: contains,
      tag: tag,
      current: current,
    },
    success: function(data) {
      var dataArray = JSON.parse(data),
      current = parseInt(dataArray['current'], 10),
      id = dataArray['id'];
              var max = parseInt(dataArray['max'], 10); // Ensure max is correctly updated from response

              console.log(id);

              $('#' + id + ' .current-page').html(current);
              $('.load-more').attr('data-current', current);
              $('.load-more').attr('data-max', max); // Update the max value
              $('#' + id + ' .pf-filter-list').append(dataArray['html']); // Append to the existing row
              setTimeout(function() {
                AOS.refresh();
              }, 200);
              setTimeout(function() {
                $('#' + id + ' .pf-post-card:not(.aos-animate)').addClass('aos-animate');
              }, 400);

              $('#' + id + ' .pagination-count svg').hide();
              if (current >= max) {
                $('#' + id + ' .pagination-count .no-posts').show();
              } else {
                $('#' + id + ' .load-more').show();
              }
            },
            error: function(jqXHR, textStatus, errorThrown) {
              console.log(jqXHR);
              console.log(textStatus);
              console.log(errorThrown);
            },
          });
});

    //News Media
    $(document).on('click', '.load-more-media', function(e) {
      e.preventDefault();

      var id = $(this).attr('data-section'),
      postType = $(this).attr('data-post-type'),
      contains = $(this).attr('data-contains'),
      tag = $(this).attr('data-tag'),
      current = parseInt($(this).attr('data-current'), 10),
      max = $(this).attr('data-max');

      console.log(id);

      $('.load-more-media').attr('data-contains', contains);
      $('.load-more-media').attr('data-tag', tag);
      $('#' + id + ' .load-more-media').hide();
      $('#' + id + ' .pagination-count-media svg').show();
      $('#' + id + ' .pagination-count-media .no-posts').hide();

      $.ajax({
        url: ajaxurl + '?action=loadMorePostsMedia',
        type: 'post',
        data: {
          section: id,
          postType: postType,
          contains: contains,
          tag: tag,
          current: current,
        },
        success: function(data) {
          var dataArray = JSON.parse(data),
          current = parseInt(dataArray['current'], 10),
          id = dataArray['id'];
              var max = parseInt(dataArray['max'], 10); // Ensure max is correctly updated from response

              console.log(id);

              $('#' + id + ' .current-page').html(current);
              $('.load-more-media').attr('data-current', current);
              $('.load-more-media').attr('data-max', max); // Update the max value
              $('#' + id + ' .pf-filter-list-media').append(dataArray['html']); // Append to the existing row
              setTimeout(function() {
                AOS.refresh();
              }, 200);
              setTimeout(function() {
                $('#' + id + ' .pf-post-card:not(.aos-animate)').addClass('aos-animate');
              }, 400);

              $('#' + id + ' .pagination-count-media svg').hide();
              if (current >= max) {
                $('#' + id + ' .pagination-count-media .no-posts').show();
              } else {
                $('#' + id + ' .load-more-media').show();
              }
            },
            error: function(jqXHR, textStatus, errorThrown) {
              console.log(jqXHR);
              console.log(textStatus);
              console.log(errorThrown);
            },
          });
    });


    // Nav Animation

    let pstl = gsap.timeline({
      scrollTrigger: {
        trigger: '.marker',
        scrub: true,
        start:"top 50px",
      },
    });
    pstl.to('.nav-wrap', { backgroundColor: 'rgba(0, 3, 26, 0.9)', duration: 0.5 })

    $('.smooth, .smooth a').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        $('.top-bar').removeClass('open');
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({scrollTop: target.offset().top - 90}, 1000); // Set scroll speed here
          return false;
        }
      }
    });

    if ($('.expanding-image-list').length !== -1) {
      var eil = false;
      $(document).on('mouseenter', '.expanding-image-list > .columns:not(.expanded)', function(e) {
        if (eil == false) {
          eil = true;
          window.setTimeout(function () { eil = false }, 400);
          $(this).parent().find('.expanded').removeClass('expanded');
          $(this).addClass('expanded');
        }
      });
    }

    $('.no-link a').on('click', function(event) {
      event.preventDefault();
    });

    // Nav/Hamburger

    $('.hamburger').on('click', function() {
      $(this).toggleClass('is-active');
      $('.top-bar').toggleClass('open');
      $('html').toggleClass('overflow');
      $('.mega-menu').removeClass('show');
    });

    $('.bank-wrap').on('click', function() {
      $(this).next().children('.link-bank').toggleClass('show');
    });

    $('.has-children a').on('mouseenter', function() {
      $(this).parent().children('.mega-menu').addClass('show');
      $(this).parent().siblings().children('.mega-menu').removeClass('show');
      $(this).parent().addClass('active');
      $(this).parent().siblings().removeClass('active');
    });

    $('.mega-menu').on('mouseleave', function() {
      $(this).parent().children('.mega-menu').removeClass('show');
      $(this).parent().siblings().children('.mega-menu').removeClass('show');
      $(this).parent().removeClass('active');
      $(this).parent().siblings().removeClass('active');
    });

    $('.wrap.container').on('click', function() {
      $('.mega-menu').removeClass('show');
      $('.has-children').removeClass('active');
    });

    // END Nav/Hamburger

    $('.tabs-title .txt-link').on('click', function() {
      window.location.href = $(this).attr('href');
    });

    $('.mq-slide').slick({
      arrows: false,
      dots: false,
    });

    $('.video-slider').slick({
      arrows: false,
      dots: true,
    });

    $('.case-study-slider').slick({
      arrows: false,
      dots: true,
      centerMode: false,
    });

    $('.video-title:first').addClass('highlight');

    $('.video-slider').on('afterChange', function(event, slick, currentSlide) {
      $('.video-title').removeClass('highlight');
      $('.video-title-' + currentSlide).addClass('highlight');
    });

    $('.stack-slider').slick({
      arrows: false,
      dots: true,
    });

    $('.product-card-slider').slick({
      arrows: false,
      dots: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    });

    $('.resources-slider').slick({
      prevArrow: '<button type="submit" class="slick-prev" aria-label="next resources"><svg width="21" height="47" viewBox="0 0 21 47" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: scaleX(-1);"><mask id="path-1-inside-1_1413_452" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 46.3888L21 23.1944L0 0V4.46981L16.9531 23.1944L0 41.919V46.3888Z"/></mask><path d="M0 46.3888H-33V132.005L24.463 68.5374L0 46.3888ZM21 23.1944L45.463 45.343L65.5161 23.1944L45.463 1.04584L21 23.1944ZM0 0L24.463 -22.1486L-33 -85.6163V0H0ZM0 4.46981H-33V17.1894L-24.463 26.6184L0 4.46981ZM16.9531 23.1944L41.4161 45.343L61.4692 23.1944L41.4161 1.04584L16.9531 23.1944ZM0 41.919L-24.463 19.7705L-33 29.1995V41.919H0ZM24.463 68.5374L45.463 45.343L-3.46304 1.04584L-24.463 24.2403L24.463 68.5374ZM45.463 1.04584L24.463 -22.1486L-24.463 22.1486L-3.46304 45.343L45.463 1.04584ZM-33 0V4.46981H33V0H-33ZM41.4161 1.04584L24.463 -17.6788L-24.463 26.6184L-7.50996 45.343L41.4161 1.04584ZM24.463 64.0676L41.4161 45.343L-7.50996 1.04584L-24.463 19.7705L24.463 64.0676ZM-33 41.919V46.3888H33V41.919H-33Z" fill="#0E3852" mask="url(#path-1-inside-1_1413_452)"/></svg></button>',
      nextArrow: '<button type="submit" class="slick-next" aria-label="previous resources"><svg width="21" height="47" viewBox="0 0 21 47" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_1413_452" fill="white"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 46.3888L21 23.1944L0 0V4.46981L16.9531 23.1944L0 41.919V46.3888Z"/></mask><path d="M0 46.3888H-33V132.005L24.463 68.5374L0 46.3888ZM21 23.1944L45.463 45.343L65.5161 23.1944L45.463 1.04584L21 23.1944ZM0 0L24.463 -22.1486L-33 -85.6163V0H0ZM0 4.46981H-33V17.1894L-24.463 26.6184L0 4.46981ZM16.9531 23.1944L41.4161 45.343L61.4692 23.1944L41.4161 1.04584L16.9531 23.1944ZM0 41.919L-24.463 19.7705L-33 29.1995V41.919H0ZM24.463 68.5374L45.463 45.343L-3.46304 1.04584L-24.463 24.2403L24.463 68.5374ZM45.463 1.04584L24.463 -22.1486L-24.463 22.1486L-3.46304 45.343L45.463 1.04584ZM-33 0V4.46981H33V0H-33ZM41.4161 1.04584L24.463 -17.6788L-24.463 26.6184L-7.50996 45.343L41.4161 1.04584ZM24.463 64.0676L41.4161 45.343L-7.50996 1.04584L-24.463 19.7705L24.463 64.0676ZM-33 41.919V46.3888H33V41.919H-33Z" fill="#0E3852" mask="url(#path-1-inside-1_1413_452)"/></svg></button>',
      arrows: true,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    $('.logo-slider-condensed').slick({
      dots: false,
      arrows: false,
      slidesToShow: 6,
      slidesToScroll: 3,
      autoplay: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      ],
    });

    $('.buckets-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoPlaySpeed: 30000,
      infinite: true,
      centerMode: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $('.buckets-slider-cul').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoPlaySpeed: 30000,
      infinite: true,
      centerMode: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $('.culture-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoPlaySpeed: 30000,
      infinite: true,
      //centerMode: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $('.diversity-slider').slick({
      arrows: false,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoPlaySpeed: 30000,
      infinite: true,
      centerMode: false,
    });

    $('.quote-slider-full').slick({
      prevArrow: '<button type="submit" class="slick-prev" aria-label="next quote"><svg xmlns="http://www.w3.org/2000/svg" width="41.778" height="36.04" viewBox="0 0 41.778 36.04"><path id="Path_6120" data-name="Path 6120" d="M22.842,0,19.124,3.968,31.332,15.407H0v5.438H31.107L19.124,32.073l3.718,3.967L41.778,18.3l-.26-.277.26-.277Z" transform="translate(41.778 36.04) rotate(180)" fill="rgba(255,255,255,0.34)"/></svg></button>',
      nextArrow: '<button type="submit" class="slick-next" aria-label="previous quote"><svg xmlns="http://www.w3.org/2000/svg" width="41.778" height="36.04" viewBox="0 0 41.778 36.04"><path d="M22.842,0,19.125,3.968,31.332,15.407H0v5.438H31.108L19.125,32.073l3.718,3.967L41.778,18.3l-.26-.277.26-.277Z" transform="translate(0)" fill="rgba(255,255,255,0.34)"/></svg></button>',
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
    });

    $('.logo-slider').slick({
      dots: false,
      arrows: true,
      prevArrow: '<button type="submit" class="slick-prev"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="submit" class="slick-next"><i class="far fa-arrow-right"></i></button',
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
      ],
    });

    $('.sm-list').slick({
      arrows: false,
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $(document).on('click', '.fdl-item__title', function(e) {
      $(this).toggleClass('open');
    });

    // $('.accordion-title-in').on('click', function(event) {
    //   $(this).next().fadeToggle();
    //   $(this).parent().siblings().children('.accordion-content-inner').hide();
    //   event.preventDefault();
    // });

    // $('.accordion-content-inner').first().css('display', 'block');
    // $('.accordion-title-in').first().addClass('open');

    // $('.accordion-title-in').on('click', function(event) {
    //   $(this).next().fadeToggle();
    //   $(this).toggleClass('open');
    //   $(this).parent().siblings().children('.accordion-content-inner').not($(this).next()).hide();
    //   $(this).parent().siblings().find('.accordion-title-in').removeClass('open');
    //   event.preventDefault();
    // });

    $('.accordion-content-inner').first().css('display', 'block');
    $('.accordion-title-in').first().addClass('open');

    $('.accordion-title-in').on('click', function(event) {
      if (!$(this).hasClass('open')) {
        $('.accordion-title-in.open').removeClass('open');
        $('.accordion-content-inner').hide();

      // Open the clicked accordion
      $(this).next().fadeIn();
      $(this).addClass('open');
    }

    event.preventDefault();
  });

    var quoteSlider = $(".quote-slider-full");

    if ($('body').hasClass('home') || $('body').hasClass('solutions-payers') || $('body').hasClass('careers')) {

      $(window).on("scroll", function() {
        var windowHeight = $(window).height();
        var scrollTop = $(window).scrollTop();
        var sectionOffset = quoteSlider.offset().top;

        if ($('body').hasClass('home')) {
          if (scrollTop + windowHeight >= sectionOffset) {
            quoteSlider.addClass("animate-quotes");
          } else {
            quoteSlider.removeClass("animate-quotes");
          }
        }

        if ($('body').hasClass('solutions-payers')) {
          if (scrollTop + windowHeight >= sectionOffset) {
            quoteSlider.addClass("animate-quotes");
          } else {
            quoteSlider.removeClass("animate-quotes");
          }
        }

        if ($('body').hasClass('careers')) {
          if (scrollTop + windowHeight >= sectionOffset) {
            quoteSlider.addClass("animate-quotes");
          } else {
            quoteSlider.removeClass("animate-quotes");
          }
        }
      });

    }

    const animVideo = gsap.utils.toArray('.animation-video')

    animVideo.forEach(function(video, i) {

      ScrollTrigger.create({
        trigger: video,
        scroller: '.media-area',
        start: 'top center',
        end: 'bottom center',
        onEnter: () => video.play(),
        onEnterBack: () => video.play(),
        onLeave: () => video.pause(),
        onLeaveBack: () => video.pause(),
      });

    })

    if ($('body').hasClass('careers')) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get('gh_jid')) {
        $('html, body').animate({'scrollTop': $('#content-job-postings').offset().top }, 1000);
      }
    }

    if ($('body').hasClass('assessment-landing')) {
      // const boxes = gsap.utils.toArray('.box-wrap');
      // boxes.forEach((box) => {
      //   gsap.from(box, {
      //     stagger: 0.2,
      //     scrollTrigger: {
      //       start: 'top center',
      //       trigger: box,
      //       toggleClass: 'selected',
      //     },
      //   });
      // });

      const boxwrap = document.querySelectorAll('.box-wrap');
      const boxes = document.querySelectorAll('.box');
      const borders = document.querySelectorAll('.box .border');
      const bgs = document.querySelectorAll('.bg');
      let glowboxes = gsap.timeline({
        duration: 1,
        scrollTrigger: {
          trigger: '.section-2',
          start: 'top bottom',
        },
      })
      glowboxes.to(boxes, {backgroundColor: 'rgba(68, 121, 167, 0.5)', border: '3px solid #c7d4d8', duration: 1.5, stagger: 0.5, ease: 'power4.out'})
      .to(bgs, {opacity: 0.5, stagger: 0.6, duration: 1.5, ease: 'power4.out'}, '-=2')
      .to(borders, {opacity: 0.5, stagger: 0.7, duration: 1.5, ease: 'power4.out'}, '-=2.5')

    }

    if ($('body').hasClass('assessment-landing')) {

      if (window.matchMedia("(max-width: 768px)").matches) {
        const vid = document.querySelector('.steps-video-mob')
        ScrollTrigger.create({
          trigger: '.section-2',
          start: 'top center',
          end: 'bottom center',
          onEnter: () => vid.play(),
          onEnterBack: () => vid.play(),
          onLeave: () => vid.pause(),
          onLeaveBack: () => vid.pause(),
        });
      } else {
        const vidmob = document.querySelector('.steps-video')
        ScrollTrigger.create({
          trigger: '.section-2',
          start: 'top 200px',
          end: 'bottom center',
          onEnter: () => vidmob.play(),
          onEnterBack: () => vidmob.play(),
          onLeave: () => vidmob.pause(),
          onLeaveBack: () => vidmob.pause(),
        });
      }
    }

    // Accordion Auto Open

    if ($('body').hasClass('faqs-payers') || $('body').hasClass('faqs-partners')) {
      console.log('working')
      const accordionItems = document.querySelectorAll(".accordion-item");
      if (accordionItems.length >= 2) {
        for (let i = 0; i < 2; i++) {
          accordionItems[i].classList.add("is-active"); // Open the accordion item
          const content = accordionItems[i].querySelector(".accordion-content");
          if (content) {
            content.style.display = "block"; // Ensure the content is visible
          }
        }
      }
    }

    $(document).on('open.zf.reveal', '#acq', function () {
      const $slider = $('.announcement-slider');

    // Check if slick has already been initialized
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        arrows: true,
        appendArrows: $('.announcement-controls'),
        prevArrow: $('.announcement-controls .slick-prev'),
        nextArrow: $('.announcement-controls .slick-next'),
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
      });
    } else {
      $slider.slick('setPosition'); // Recalculate layout if already initialized
    }
  });

    // const $slider = $('.announcement-slider-head');

    // if (!$slider.hasClass('slick-initialized')) {
    //   $slider.slick({
    //     arrows: true,
    //     prevArrow: $('.slick-prev'),
    //     nextArrow: $('.slick-next'),
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     dots: false,
    //     infinite: true,
    //   });
    // } else {
    //   $slider.slick('setPosition');
    // }

    $(document).on('closed.zf.reveal', '#acq', function () {
      sessionStorage.setItem('acqModalDismissed', 'true');
      $('.nav-wrap .callout').addClass('open');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js